<template>
  <!-- 招聘 -->
  <div>
    <div class="join-top">
      <h2 class="title">{{ $t("join.joinTitle") }}</h2>
      <div class="content">
        <ElRow class="book-wrap" v-for="item in jobList" :key="item.positionId">
          <div class="book-item" :key="item.positionId">
            <div class="book-content">
              <div class="book-name">
                <div class="book-title" @click="onOpen(item)">
                  {{ item.positionName }} {{ item.companyName }}
                </div>
                <div>{{ item.dateStart }}</div>
              </div>
              <p class="book-desc">{{ `${item.city} | ${item.payment}` }}</p>
              <p class="book-desc">{{ item.positionDescription }}</p>
              <div class="book-flex">
                <!-- <div class="book-welfare">{{ welfare }}</div> -->
                <!-- <el-button type="text" @click="applyJob(item)">{{
                  $t("join.application")
                }}</el-button> -->
              </div>
            </div>
          </div>
        </ElRow>
        <div class="pager-wrapper">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="formInline.pageNum"
            :page-sizes="[5, 10]"
            :page-size="formInline.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { GetPositionsList, GetWelfareInfo } from "../../../api/web";

export default {
  name: "join",
  data() {
    return {
      jobList: [],
      welfare: "",
      formInline: {
        pageNum: 1,
        pageSize: 5,
        companyId: 2,
      },
      total: 0,
    };
  },
  methods: {
    init() {
      const comDic = {
        1: this.$t("join.clinical"),
        2: this.$t("join.meta"),
        3: this.$t("join.cric"),
      };
      GetPositionsList(this.formInline).then((res) => {
        if (res.status) {
          res.data.dataList.forEach((item) => {
            item.dateStart = moment(item.dateStart).format("YYYY-MM-DD");
            item.companyName = comDic[item.companyId];
          });
          this.total = res.data.total;
          this.jobList = res.data?.dataList || [];
        }
      });
      GetWelfareInfo().then((res) => {
        if (res.status) {
          this.welfare = res.data;
        }
      });
    },
    applyJob(info) {
      const { companyId, positionId } = info;
      this.$router.push({
        name: "APPLICATION",
        query: { positionId, companyId },
      });
    },
    onOpen(info) {
      const { companyId, positionId } = info;
      sessionStorage.setItem('companyId', companyId);
      sessionStorage.setItem('positionId', positionId);
      this.$router.push({ name: "DETAIL", query: { positionId, companyId } });
    },
    handleSizeChange(val) {
      this.formInline.pageSize = val;
      this.init();
    },
    handleCurrentChange(val) {
      this.formInline.pageNum = val;
      this.init();
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style lang="less" scoped>
@import "../../../style/constant";
.join-top {
  max-width: @page-width;
  margin: 0 auto;

  .title {
    font-weight: 500;
    font-size: 32px;
    line-height: 1.2em;
    color: @title-color;
    text-align: center;
    margin-bottom: 60px;
  }

  .content {
    max-width: @page-width;
    margin: 0 auto;
    // padding-bottom: 80px;
    // padding-top: 50px;
    .pager-wrapper {
      margin-top: 10px;
      text-align: right;
    }
    .book-wrap {
      // padding-top: 60px;

      // &:nth-child(1) {
      //   padding-top: 30px;
      // }

      // &:nth-child(2) {
      //   padding-top: 30px;
      // }

      // &:nth-child(3) {
      //   padding-top: 30px;
      // }
    }

    .book-item {
      // max-width: 280px;
      margin: 0 auto 20px;
      box-shadow: 1px 1px 5px #c3c3c3;
      background-color: white;

      .cover {
        height: 180px;
        text-align: center;
        border-bottom: 1px solid #d4d4d4;
        overflow: hidden;

        img {
          width: 50%;
          height: 100%;
          object-fit: fill;
        }
      }

      .book-content {
        padding: 20px 40px;

        .book-name {
          display: flex;
          justify-content: space-between;
          font-size: 18px;
          .book-title {
            font-weight: bold;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            color: #0058a6;
            &:hover {
              cursor: pointer;
              color: #e76c5e;
            }
          }
        }
        .book-flex {
          display: flex;
          justify-content: space-between;
          .book-welfare {
            padding: 12px 0;
            width: 650px;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
          }
        }

        .book-desc {
          margin-top: 10px;
          // min-height: 36px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 3;
          -webkit-box-orient: vertical;
        }

        .more {
          color: #435ba1;
          cursor: pointer;
          text-align: right;
          margin-top: 15px;

          &:hover {
            color: #e76c5e;
          }
        }
      }
    }
  }

  .block {
    width: 170px;
    height: 210px;
    background: #fafafa;
    border-radius: 8px;
    margin: 0 auto;
    transition: box-shadow 0.5s;
    -webkit-transition: box-shadow 0.5s;

    a {
      text-decoration: none;
    }

    &:hover {
      cursor: pointer;
      box-shadow: 0 5px 10px rgba(49, 100, 175, 0.14);
    }

    .iconjob_offers {
      font-size: 60px;
      padding-top: 40px;
      display: inline-block;
      color: #3164af;
    }

    .block-title {
      font-size: 16px;
      font-weight: 400;
      color: #3164af;
    }
  }
}
@media screen and (max-width: 996px) {
  h2 {
    font-size: 25px !important;
  }
}
</style>
